/* global TradeInValuations */
// FLOW 2

import React, { Component } from "react"
import PropTypes from "prop-types"
import ThankYouMessage from "./ThankYouMessage"
import LeadForm from "./LeadForm"
import StepReplacementCar from "./StepReplacementCar"
import TradeInResult from "./TradeInResult"
import { trackFunction } from "website_script/lib/iframeTrackingHelper"

class FlowValuationThenLeadForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      proceedToLead: false,
    }
  }

  render() {
    const {
      leadSent,
      leadFormHtml,
      carSummaryHtml,
      tradeInResult,
      proceedToLeadText,
      displayValuation,
      thankYouTextWhenValuated,
      thankYouTextWhenNoValuation,
      thankYouAdditionalText,
      removeThankYouCheckmark,
      replacementCarSearch,
      replacementCarChosen,
      handleEditReplacementCar,
      onLeadFormFieldValuesCaptured,
      leadFormFieldValues,
      leadFormStrings,
    } = this.props

    const { proceedToLead } = this.state

    return (
      <div>
        {!leadSent ? (
          !proceedToLead ? (
            <div>
              <TradeInResult
                {...tradeInResult}
                carSummaryHtml={carSummaryHtml}
                trackFunction={trackFunction}
              />
              <div className="lead-form-wrapper">
                <button
                  className="button primary lead-form-cta main-cta"
                  onClick={() => this.setState({ proceedToLead: true })}
                >
                  {proceedToLeadText}
                </button>
              </div>
            </div>
          ) : replacementCarSearch.enabled && !replacementCarChosen ? (
            <StepReplacementCar {...replacementCarSearch} />
          ) : (
            <LeadForm
              leadFormHtml={leadFormHtml}
              onEditReplacementCar={handleEditReplacementCar}
              replacementCar={replacementCarSearch.preselectedCarInfo}
              onFieldValuesCaptured={onLeadFormFieldValuesCaptured}
              fieldValues={leadFormFieldValues}
              strings={leadFormStrings}
              trackFunction={trackFunction}
            />
          )
        ) : (
          <div>
            <div dangerouslySetInnerHTML={{ __html: carSummaryHtml }} />
            <ThankYouMessage
              text={
                displayValuation
                  ? thankYouTextWhenValuated
                  : thankYouTextWhenNoValuation
              }
              additionalText={thankYouAdditionalText}
              removeThankYouCheckmark={removeThankYouCheckmark}
            />
          </div>
        )}
      </div>
    )
  }
}

FlowValuationThenLeadForm.propTypes = {
  leadSent: PropTypes.bool,
  carSummaryHtml: PropTypes.string,
  tradeInResult: PropTypes.object,
  leadFormHtml: PropTypes.string,
  proceedToLeadText: PropTypes.string,
  displayValuation: PropTypes.bool,
  thankYouTextWhenValuated: PropTypes.string,
  thankYouTextWhenNoValuation: PropTypes.string,
  thankYouAdditionalText: PropTypes.string,
  removeThankYouCheckmark: PropTypes.bool,
  replacementCarSearch: PropTypes.object,
  replacementCarChosen: PropTypes.bool,
  handleEditReplacementCar: PropTypes.func,
  onLeadFormFieldValuesCaptured: PropTypes.func,
  leadFormFieldValues: PropTypes.array,
  leadFormStrings: PropTypes.object,
}

export default FlowValuationThenLeadForm
